import AppConstants from 'constants/AppConstants';

/**
 * Fetch a business's details
 *
 * @param {number} id The id of the business to fetch.
 * @returns {Object} A redux TockApi action.
 */
export function fetch(domain: string): ApiAction {
  if (!domain) {
    window.LOGGER?.warn('Business is null');
  }
  return {
    TockApi: {
      getProto: `/consumer/config?domain=${domain}`,
      type: AppConstants.BUSINESS_FETCH,
    },
  };
}

export function clearBusiness(): BaseTockAction {
  return {
    type: AppConstants.BUSINESS_CLEAR,
  };
}
